module.exports = __webpack_public_path__ + "static/media/Upper-Body.792dfa69.jpeg";